interface CredentialTypes {
  email: string | undefined;
  password: string | undefined;
}

async function loginUser(credentials: CredentialTypes) {
  const requestOptions = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(credentials),
  };

  return fetch(
    `${import.meta.env.VITE_BASE_URL}/api/users/authentication`,
    requestOptions
  ).then((data) => data.json());
}

async function loginGoogleUser() {
  const requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(credentials),
  };

  return await fetch(
    `${import.meta.env.VITE_BASE_URL}/api/users/authgoogle`,
    requestOptions
  ).then((data) => data.json());
}

async function loginFacebookUser() {
  const requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    // body: JSON.stringify(credentials),
  };

  return await fetch(
    `${import.meta.env.VITE_BASE_URL}/api/users/authfacebook`,
    requestOptions
  ).then((data) => data.json());
}

export { loginUser, loginGoogleUser, loginFacebookUser };
